import { atom } from "jotai";

export interface Toast {
  id: string;
  message: string;
}

export const demoToastState = atom<Toast[]>([]);
